//document ready
$(function() {

    var allPanels = $('.accordion > dd').hide();

    $('.accordion > dt > a').click(function() {
        if (!$(this).parent().next().is(":visible")) {
            allPanels.slideUp();
            $('.accordion small.right').html('&#9668;');
            $(this).find('small.right').html('&#9660;');
            $(this).parent().next().slideDown();
        }
        return false;
    });

    var oldFlickityCreate = window.Flickity.prototype._create;

    window.Flickity.prototype._create = function() {
        var that = this;
        if (this.element.addEventListener) {
            this.element.addEventListener('load', function() {
                that.onresize();
            }, true);
        }
        this._create = oldFlickityCreate;
        return oldFlickityCreate.apply(this, arguments);
    }
    ;

    objectFitImages();
    header.loadMegaMenu();
    header.init();

    searchAutocomplete.init();

    utils.pageBannerCheck();
    slideshow.init();
    testimonial.init();
    videoSection.init();
    gallery.init();
    featuredPromotions.init();
    featuredCollectionSection.init();
    collectionSidebarFilter.init();
    cart.init();
    mapFunction.init();

    productPage.initializeQuantityBox();
    productPage.init();
    productPage.relatedProducts();

    recentlyViewed.init();

    // Setup a timer
    var resizeTimeout;

    // Listen for resize events
    window.addEventListener('resize', function(event) {

        // If timer is null, reset it to 66ms and run your functions.
        // Otherwise, wait until timer is cleared
        if (!resizeTimeout) {
            resizeTimeout = setTimeout(function() {

                // Reset timeout
                resizeTimeout = null;

                // Run our resize functions
                if ($(window).width() <= 798) {
                    cart.init();
                    header.unload();
                    header.init();
                }

            }, 66);
        }
    }, false);

    //Lightbox default options
    //https://fancyapps.com/fancybox/3/docs/#options
    $.fancybox.defaults.animationEffect = 'fade';
    $.fancybox.defaults.transitionEffect = 'fade';
    $.fancybox.defaults.hash = false;
    $.fancybox.defaults.infobar = false;
    $.fancybox.defaults.toolbar = false;
    $.fancybox.defaults.arrows = false;
    $.fancybox.defaults.loop = true;
    $.fancybox.defaults.smallBtn = true;
    $.fancybox.defaults.live = false;
    $.fancybox.defaults.zoom = false;
    $.fancybox.defaults.mobile.preventCaptionOverlap = false;
    $.fancybox.defaults.mobile.toolbar = true;
    $.fancybox.defaults.mobile.buttons = ['close'];
    $.fancybox.defaults.mobile.clickSlide = 'close';
    $.fancybox.defaults.mobile.clickContent = 'zoom';
    $.fancybox.defaults.afterLoad = function(instance, slide) {
        if (instance.current.type == 'image') {
            slide.$content.wrapInner("<div class='fancybox-image-wrap'></div>")
        }
        if (instance.group.length > 1) {
            slide.$content.find('.fancybox-image-wrap').append('<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>' + svgArrowSizeLeft + '</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>' + svgArrowSizeRight + '</span></a>')
        }
    }

    //backwards compatibility with custom lightboxes
    $('.lightbox[rel="gallery"]').fancybox();

    //Search input hiding
    //get current input
    var currentValue = $(".search_form input[name='q']").val()
    //return amount without *
    if ($(".search_form input[name='q']").length > 0) {
        $(".search_form input[name='q']").val(currentValue.replace('*', ''));
    }

    $('#sort-by').val($('#sort-by').data('default-sort'));

    $('body').on('change', '#tag_filter, #sort-by', function() {
        quickFilter.init();
    });

    $('body').on('change', '#blog_filter', function() {
        var url = $(this).val();
        window.location = url;
    });

    $('input, select, textarea').on('focus blur', function(event) {
        $('meta[name=viewport]').attr('content', 'width=device-width,initial-scale=1,maximum-scale=' + (event.type == 'blur' ? 10 : 1));
    });

    //Collection sidebar filter
    //Check the checkbox values
    $('body').on('change', '[data-option-filter] input', function() {
        quickFilter.init();
        $("html, body").animate({
            scrollTop: ($('#pagecontent').offset().top)
        }, 500);
    })

    $('body').on('click', '[data-reset-filters]', function() {
        collectionSidebarFilter.clearAllFilters();
    });

    $('body').on('click', '[data-clear-filter]', function() {
        var selectedOption = $(this).parents('.filter-active-tag');
        collectionSidebarFilter.clearSelectedFilter(selectedOption);
    });

    $('body').on('change', '.currencies', function(e) {
        $('[data-initial-modal-price]').attr('data-initial-modal-price', '');
    });

    $('body').on('change', '.js-quick-shop select', function(e) {
        var currentVariant = $('.js-quick-shop select[name="id"]').val();
        if (currentVariant && globalQuickShopProduct) {
            quickShop.updateVariant(currentVariant);
        }
    });

    quickShop.init();

    var touchStartPos = 0;

    //Detecting swipe vs tap
    $(document).bind("touchstart", function(e) {
        touchStartPos = $(window).scrollTop();
    }).bind("touchend", function(e) {
        var distance = touchStartPos - $(window).scrollTop();
        if (distance > 20 || distance < -20) {
            e.preventDefault;
        }
    });

    $('body').on('click', '.sidebar .parent-link--false', function(e) {
        e.preventDefault();
        $menu = $(this).parent('li');
        $menu.find('.menu-toggle').toggleClass('active');
        $menu.find('ul').slideToggle();
    });

    if (window.location.pathname.indexOf('/comments') != -1) {
        $('html,body').animate({
            scrollTop: $("#new-comment").offset().top - 140
        }, 'slow');
    }

    $('body').on('mouseenter', '.icon-search', function() {
        $('.search-terms').focus();
    });

    $('body').on('click', '.icon-search', function() {
        $('input.search-terms').focus();
    });

    $('body').on('click', '.search-submit', function() {
        $(this).parent().submit();
    });

    if ($(window).width() > 798) {
        $(".animate_right").waypoint(function() {
            $(this.element).addClass("animated fadeInRight");
        }, {
            offset: '70%'
        });
        $(".animate_left").waypoint(function() {
            $(this.element).addClass("animated fadeInLeft");
        }, {
            offset: '70%'
        });
        $(".animate_up").waypoint(function() {
            $(this.element).addClass("animated fadeInUp");
        }, {
            offset: '70%'
        });
        $(".animate_down").waypoint(function() {
            $(this.element).addClass("animated fadeInDown");
        }, {
            offset: '70%'
        });
    }

    //backwards compatibility with flexslider
    $('.slider, .flexslider').find('li').unwrap();
    $('.slider, .flexslider').flickity({
        pageDots: usePageDots,
        imagesLoaded: true,
        arrowShape: arrowSize,
        lazyLoad: 2
    });

    utils.createAccordion('.toggle-all--true', 'h4.toggle', 'ul.toggle_list');
    utils.createAccordion('.footer_menu', 'h6', 'ul');
    utils.createAccordion('.footer_content', 'h6', 'div.toggle_content');
    utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');

    utils.mobileParentActiveAccordion('#mobile_menu', 'li.sublink > a.parent-link--true span', 'li.sublink ul');
    utils.mobileAccordion('#mobile_menu', 'li.sublink > a.parent-link--false', 'li.sublink ul');

    utils.initializeTabs();
    utils.resizeActionButtons();
    faqAccordion.init();

    $(window).on('resize', function() {
        utils.resizeActionButtons();
    });

    //Sidebar toggle check
    if ($(window).width() <= 798) {
        utils.createAccordion('.toggle-all--false', 'h4.toggle', 'ul.toggle_list');
    }

    $('body').on('click', '.menu-toggle', function(e) {
        var $content = $(this).next('ul');
        $content.slideToggle();
        $(this).toggleClass('active');
        $(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'true' ? 'false' : 'true');
    });

    if ($(window).width() >= 959) {
        var modal_width = '870px';
        if ($(window).width() >= 1200 || $('html').hasClass('ie')) {
            modal_width = '1110px'
        }
    }

    //Terms of service settings for minicart

    $('body').on('click touchstart', '.cart_content .tos_label', function() {
        $(this).prev('input').prop('checked', true);
    });

    $('body').on('click', ".cart_content .action_button", function(e) {
        // Redirect to cart page
        e.preventDefault();
        document.location.href = "/cart";
    });

    var $contact_form = $('.newsletter .contact-form');
    $contact_form.each(function() {
        var $cf = $(this);
        $cf.on('submit', function(e) {
            if ($('input[name="challenge"]', $cf).val() !== "true") {
                $.ajax({
                    type: $cf.attr('method'),
                    url: $cf.attr('action'),
                    data: $cf.serialize(),
                    success: function(data) {
                        $cf.fadeOut("slow", function() {
                            $cf.prev('.message').html("Thank you for joining our mailing list!");
                        });
                    },
                    error: function(data) {
                        $('input[name="challenge"]', $cf).val('true');
                        $cf.submit();
                    }
                });
                e.preventDefault();
            }
        });
    });

    $('.maps').click(function() {
        $('.maps iframe').css("pointer-events", "auto");
    });

    /*============================================================================
    Start of cart-related functionality
  ==============================================================================*/

    function ajaxSubmitCart(cart) {
        $cart = cart;
        $.ajax({
            url: '/cart/update.js',
            dataType: 'json',
            cache: false,
            type: 'post',
            data: $cart.serialize(),
            success: function(data) {
                refreshCart(data);
            }
        });
    }

    function ajaxUpdateCart(lineID, quantity, parent) {
        $.ajax({
            url: '/cart/change.js',
            dataType: 'json',
            cache: false,
            type: 'post',
            data: {
                quantity: quantity,
                line: lineID
            },
            success: function(data) {
                refreshCart(data);

                var lineIDIndex = lineID - 1;

                //check to see if there are correct amount of products in array
                if (typeof data.items[lineIDIndex] === "undefined") {
                    var updated_quantity = 0;
                } else {
                    var updated_quantity = data.items[lineIDIndex].quantity;
                }

                if (quantity > 0 && quantity != updated_quantity) {
                    if (updated_quantity == 1) {
                        items_left_text = "item left";
                    } else {
                        items_left_text = "items left";
                    }

                    $('.warning--quantity').remove();

                    var warning = '<p class="warning warning--quantity animated bounceIn">' + updated_quantity + ' ' + items_left_text + '</p>';
                    parent.find("input[data-line-id='" + lineID + "']").parent().after(warning);
                    parent.find("input[data-line-id='" + lineID + "']").val(updated_quantity);
                } else if (parent.is('#cart_form')) {
                    $("#cart_form").submit();
                }
            }
        });
    }

    function refreshCart(cart) {

        $(".cart_count").empty();
        $cartBtn = $(".cart_count");
        var value = $cartBtn.text() || '0';
        var cart_items_html = "";
        var cart_action_html = "";
        var cart_savings_html = "";
        var $cart = $(".cart_content form");
        var discounted_price_total = 0;
        var total_savings = 0;

        $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));

        if (cart.item_count == 0) {
            $('.js-empty-cart__message').removeClass('hidden');
            $('.js-cart_content__form').addClass('hidden');
        } else {
            $('.js-empty-cart__message').addClass('hidden');
            $('.js-cart_content__form').removeClass('hidden');

            $.each(cart.items, function(index, item) {
                var sellingPlan = "";
              
                if(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan){
                  sellingPlan = item.selling_plan_allocation.selling_plan.name;
                }
                var line_id = index + 1;
                cart_items_html += '<li class="cart_item clearfix">' + '<a href="' + item.url + '">';
                if (item.image) {
                    cart_items_html += '<div class="cart_image">' + '<img src="' + item.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' + '</div>';
                }

                cart_items_html += '<div class="cart_item__title"><div class="item_title">' + item.title;

                if (item.properties) {
                    $.each(item.properties, function(title, value) {
                        if (value) {
                            cart_items_html += '<div class="line-item">' + title + ': ' + value + '</div>';
                        }
                    });
                }
                cart_items_html += '<br>'+sellingPlan;

                cart_items_html += '</div></a>';

                cart_items_html += '<div class="left product-quantity-box">' + '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>' + '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity + '" data-line-id="' + line_id + '" />' + '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>' + '</div>' + '</div>';

                cart_items_html += '<strong class="right price">';

                cart_items_html += '<span class="money">' + Shopify.formatMoney(item.price, $('body').data('money-format')) + '</span></strong>' + '</div>';

            });

            cart_action_html += '<span class="right"><span class="money">' + Shopify.formatMoney(cart.total_price, $('body').data('money-format')) + '</span></span>' + '<span>Subtotal</span>';

            if (total_savings > 0) {
                cart_savings_html = '<span class="right"><span class="money">' + Shopify.formatMoney(total_savings - discounted_price_total, $('body').data('money-format')) + '</span></span>' + '<span>Total Savings</span>';
            } else {
                cart_savings_html = "";
            }
        }

        $('.js-cart_items').html(cart_items_html);
        $('.js-cart_subtotal').html(cart_action_html);
        $('.js-cart_savings').html(cart_savings_html);

    }

    $('body').on("change", "#cart_form input.quantity", function() {
        ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('#cart_form'));
    });

    $('body').on("change", ".cart_content input.quantity", function() {
        ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('.cart_content'));
    });

    $(document).on('click', '.ajax-submit', function(e) {
        e.preventDefault();
        var $addToCartForm = $(this).closest('form');
        var $addToCartBtn = $addToCartForm.find('.add_to_cart');

        $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            cache: false,
            type: 'post',
            data: $addToCartForm.serialize(),
            beforeSend: function() {
                $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
            },
            success: function(itemData) {
                $addToCartBtn.find('.checkmark').addClass('checkmark-active');

                window.setTimeout(function() {
                    $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                    $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
                    $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
                }, 1000);

                $.ajax({
                    url: '/cart.js',
                    dataType: "json",
                    cache: false,
                    success: function(cart) {
                        refreshCart(cart);
                        if ($('body').hasClass('fancybox-active')) {
                            $.fancybox.close();
                        }

                        if ($('#header').is(':visible')) {
                            $('#header .cart_container').addClass('active_link');
                        } else if ($('.sticky_nav--stick').length) {
                            $('.sticky_nav .cart_container').addClass('active_link');
                        } else {
                            $('.top_bar .cart_container').addClass('active_link');
                        }

                        //block scrolling on mobile
                        if ($(window).width() <= 798) {
                            var $cart_container = $(this).parent();
                            if ($cart_container.hasClass('active_link')) {
                                $('body').addClass('blocked-scroll');
                            } else {
                                $('body').addClass('blocked-scroll');
                            }
                        }
                    }
                });
            },
            error: function(XMLHttpRequest) {
                var response = eval('(' + XMLHttpRequest.responseText + ')');
                response = response.description;
                $('.warning').remove();

                var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
                $addToCartForm.after(warning);
                $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                $addToCartBtn.find('span').text("Add to Cart").removeClass('zoomOut').addClass('zoomIn');
            }
        });

        return false;
    });

    productPage.productSwatches();

});

/*============================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
==============================================================================*/
Shopify.updateOptionsInSelector = function(selectorIndex, parent) {

    switch (selectorIndex) {
    case 0:
        var key = 'root';
        var selector = $(parent + ' .single-option-selector:eq(0)');
        break;
    case 1:
        var key = $(parent + ' .single-option-selector:eq(0)').val();
        var selector = $(parent + ' .single-option-selector:eq(1)');
        break;
    case 2:
        var key = $(parent + ' .single-option-selector:eq(0)').val();
        key += ' / ' + $(parent + ' .single-option-selector:eq(1)').val();
        var selector = $(parent + ' .single-option-selector:eq(2)');
    }

    var availableOptions = Shopify.optionsMap[key];
    $(parent + ' .swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
        if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
            $(this).removeClass('soldout').find(':radio').removeAttr('disabled', 'disabled').removeAttr('checked');
        } else {
            $(this).addClass('soldout').find(':radio').removeAttr('checked').attr('disabled', 'disabled');
        }
    });

}
;

Shopify.linkOptionSelectors = function(product, parent) {
    // Building our mapping object.
    Shopify.optionsMap = {};
    for (var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i];
        if (variant.available) {
            // Gathering values for the 1st drop-down.
            Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
            Shopify.optionsMap['root'].push(variant.option1);
            Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
            // Gathering values for the 2nd drop-down.
            if (product.options.length > 1) {
                var key = variant.option1;
                Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                Shopify.optionsMap[key].push(variant.option2);
                Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
            }
            // Gathering values for the 3rd drop-down.
            if (product.options.length === 3) {
                var key = variant.option1 + ' / ' + variant.option2;
                Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                Shopify.optionsMap[key].push(variant.option3);
                Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
            }
        }
    }
    // Update options right away.
    Shopify.updateOptionsInSelector(0, parent);
    if (product.options.length > 1)
        Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3)
        Shopify.updateOptionsInSelector(2, parent);
    // When there is an update in the first dropdown.
    $(parent + " .single-option-selector:eq(0)").change(function() {
        Shopify.updateOptionsInSelector(1, parent);
        if (product.options.length === 3)
            Shopify.updateOptionsInSelector(2, parent);
        return true;
    });
    // When there is an update in the second dropdown.
    $(parent + " .single-option-selector:eq(1)").change(function() {
        if (product.options.length === 3)
            Shopify.updateOptionsInSelector(2, parent);
        return true;
    });
}
;

//Used for cart functionality
function htmlEncode(value) {
    if (value) {
        return $('<div/>').text(value).html();
    } else {
        return '';
    }
}

//Check if device is touch-enabled
function is_touch_device() {
    return 'ontouchstart'in window || navigator.maxTouchPoints;
}
;
/* option_selection.js */
function floatToString(t, e) {
    var o = t.toFixed(e).toString();
    return o.match(/^\.\d+/) ? "0" + o : o
}
if ("undefined" == typeof Shopify)
    var Shopify = {};
Shopify.each = function(t, e) {
    for (var o = 0; o < t.length; o++)
        e(t[o], o)
}
,
Shopify.map = function(t, e) {
    for (var o = [], i = 0; i < t.length; i++)
        o.push(e(t[i], i));
    return o
}
,
Shopify.arrayIncludes = function(t, e) {
    for (var o = 0; o < t.length; o++)
        if (t[o] == e)
            return !0;
    return !1
}
,
Shopify.uniq = function(t) {
    for (var e = [], o = 0; o < t.length; o++)
        Shopify.arrayIncludes(e, t[o]) || e.push(t[o]);
    return e
}
,
Shopify.isDefined = function(t) {
    return "undefined" == typeof t ? !1 : !0
}
,
Shopify.getClass = function(t) {
    return Object.prototype.toString.call(t).slice(8, -1)
}
,
Shopify.extend = function(t, e) {
    function o() {}
    o.prototype = e.prototype,
    t.prototype = new o,
    t.prototype.constructor = t,
    t.baseConstructor = e,
    t.superClass = e.prototype
}
,
Shopify.locationSearch = function() {
    return window.location.search
}
,
Shopify.locationHash = function() {
    return window.location.hash
}
,
Shopify.replaceState = function(t) {
    window.history.replaceState({}, document.title, t)
}
,
Shopify.urlParam = function(t) {
    var e = RegExp("[?&]" + t + "=([^&#]*)").exec(Shopify.locationSearch());
    return e && decodeURIComponent(e[1].replace(/\+/g, " "))
}
,
Shopify.newState = function(t, e) {
    var o;
    return o = Shopify.urlParam(t) ? Shopify.locationSearch().replace(RegExp("(" + t + "=)[^&#]+"), "$1" + e) : "" === Shopify.locationSearch() ? "?" + t + "=" + e : Shopify.locationSearch() + "&" + t + "=" + e,
    o + Shopify.locationHash()
}
,
Shopify.setParam = function(t, e) {
    Shopify.replaceState(Shopify.newState(t, e))
}
,
Shopify.Product = function(t) {
    Shopify.isDefined(t) && this.update(t)
}
,
Shopify.Product.prototype.update = function(t) {
    for (property in t)
        this[property] = t[property]
}
,
Shopify.Product.prototype.optionNames = function() {
    return "Array" == Shopify.getClass(this.options) ? this.options : []
}
,
Shopify.Product.prototype.optionValues = function(t) {
    if (!Shopify.isDefined(this.variants))
        return null;
    var e = Shopify.map(this.variants, function(e) {
        var o = "option" + (t + 1);
        return void 0 == e[o] ? null : e[o]
    });
    return null == e[0] ? null : Shopify.uniq(e)
}
,
Shopify.Product.prototype.getVariant = function(t) {
    var e = null;
    return t.length != this.options.length ? e : (Shopify.each(this.variants, function(o) {
        for (var i = !0, r = 0; r < t.length; r++) {
            var n = "option" + (r + 1);
            o[n] != t[r] && (i = !1)
        }
        return 1 == i ? void (e = o) : void 0
    }),
    e)
}
,
Shopify.Product.prototype.getVariantById = function(t) {
    for (var e = 0; e < this.variants.length; e++) {
        var o = this.variants[e];
        if (t == o.id)
            return o
    }
    return null
}
,
Shopify.money_format = "$",
Shopify.formatMoney = function(t, e) {
    function o(t, e) {
        return "undefined" == typeof t ? e : t
    }
    function i(t, e, i, r) {
        if (e = o(e, 2),
        i = o(i, ","),
        r = o(r, "."),
        isNaN(t) || null == t)
            return 0;
        t = (t / 100).toFixed(e);
        var n = t.split(".")
          , a = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i)
          , s = n[1] ? r + n[1] : "";
        return a + s
    }
    "string" == typeof t && (t = t.replace(".", ""));
    var r = ""
      , n = /\{\{\s*(\w+)\s*\}\}/
      , a = e || this.money_format;
    switch (a.match(n)[1]) {
    case "amount":
        r = i(t, 2);
        break;
    case "amount_no_decimals":
        r = i(t, 0);
        break;
    case "amount_with_comma_separator":
        r = i(t, 2, ".", ",");
        break;
    case "amount_with_apostrophe_separator":
        r = i(t, 2);
        break;
    case "amount_no_decimals_with_comma_separator":
        r = i(t, 0, ".", ",")
    }
    return a.replace(n, r)
}
,
Shopify.OptionSelectors = function(t, e) {
    return this.selectorDivClass = "selector-wrapper",
    this.selectorClass = "single-option-selector",
    this.variantIdFieldIdSuffix = "-variant-id",
    this.variantIdField = null,
    this.historyState = null,
    this.selectors = [],
    this.domIdPrefix = t,
    this.product = new Shopify.Product(e.product),
    this.onVariantSelected = Shopify.isDefined(e.onVariantSelected) ? e.onVariantSelected : function() {}
    ,
    this.replaceSelector(t),
    this.initDropdown(),
    e.enableHistoryState && (this.historyState = new Shopify.OptionSelectors.HistoryState(this)),
    !0
}
,
Shopify.OptionSelectors.prototype.initDropdown = function() {
    var t = {
        initialLoad: !0
    }
      , e = this.selectVariantFromDropdown(t);
    if (!e) {
        var o = this;
        setTimeout(function() {
            o.selectVariantFromParams(t) || o.fireOnChangeForFirstDropdown.call(o, t)
        })
    }
}
,
Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function(t) {
    this.selectors[0].element.onchange(t)
}
,
Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function(t) {
    var e = this.selectVariantFromParams(t);
    e || this.selectVariantFromDropdown(t)
}
,
Shopify.OptionSelectors.prototype.replaceSelector = function(t) {
    var e = document.getElementById(t)
      , o = e.parentNode;
    Shopify.each(this.buildSelectors(), function(t) {
        o.insertBefore(t, e)
    }),
    e.style.display = "none",
    this.variantIdField = e
}
,
Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function(t) {
    var e = document.getElementById(this.domIdPrefix).querySelector("[selected]");
    if (e || (e = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')),
    !e)
        return !1;
    var o = e.value;
    return this.selectVariant(o, t)
}
,
Shopify.OptionSelectors.prototype.selectVariantFromParams = function(t) {
    var e = Shopify.urlParam("variant");
    return this.selectVariant(e, t)
}
,
Shopify.OptionSelectors.prototype.selectVariant = function(t, e) {
    var o = this.product.getVariantById(t);
    if (null == o)
        return !1;
    for (var i = 0; i < this.selectors.length; i++) {
        var r = this.selectors[i].element
          , n = r.getAttribute("data-option")
          , a = o[n];
        null != a && this.optionExistInSelect(r, a) && (r.value = a)
    }
    return "undefined" != typeof jQuery ? jQuery(this.selectors[0].element).trigger("change", e) : this.selectors[0].element.onchange(e),
    !0
}
,
Shopify.OptionSelectors.prototype.optionExistInSelect = function(t, e) {
    for (var o = 0; o < t.options.length; o++)
        if (t.options[o].value == e)
            return !0
}
,
Shopify.OptionSelectors.prototype.insertSelectors = function(t, e) {
    Shopify.isDefined(e) && this.setMessageElement(e),
    this.domIdPrefix = "product-" + this.product.id + "-variant-selector";
    var o = document.getElementById(t);
    Shopify.each(this.buildSelectors(), function(t) {
        o.appendChild(t)
    })
}
,
Shopify.OptionSelectors.prototype.buildSelectors = function() {
    for (var t = 0; t < this.product.optionNames().length; t++) {
        var e = new Shopify.SingleOptionSelector(this,t,this.product.optionNames()[t],this.product.optionValues(t));
        e.element.disabled = !1,
        this.selectors.push(e)
    }
    var o = this.selectorDivClass
      , i = this.product.optionNames()
      , r = Shopify.map(this.selectors, function(t) {
        var e = document.createElement("div");
        if (e.setAttribute("class", o),
        i.length > 1) {
            var r = document.createElement("label");
            r.htmlFor = t.element.id,
            r.innerHTML = t.name,
            e.appendChild(r)
        }
        return e.appendChild(t.element),
        e
    });
    return r
}
,
Shopify.OptionSelectors.prototype.selectedValues = function() {
    for (var t = [], e = 0; e < this.selectors.length; e++) {
        var o = this.selectors[e].element.value;
        t.push(o)
    }
    return t
}
,
Shopify.OptionSelectors.prototype.updateSelectors = function(t, e) {
    var o = this.selectedValues()
      , i = this.product.getVariant(o);

  setTimeout(function() {
 if(BOLD && BOLD.BsubWidget){
  BOLD.BsubWidget._renderPrices();
 }
},50);
    i ? (this.variantIdField.disabled = !1,
    this.variantIdField.value = i.id) : this.variantIdField.disabled = !0,
    this.onVariantSelected(i, this, e),
    null != this.historyState && this.historyState.onVariantChange(i, this, e)
  
}
,
Shopify.OptionSelectorsFromDOM = function(t, e) {
    var o = e.optionNames || []
      , i = e.priceFieldExists || !0
      , r = e.delimiter || "/"
      , n = this.createProductFromSelector(t, o, i, r);
    e.product = n,
    Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, t, e)
}
,
Shopify.extend(Shopify.OptionSelectorsFromDOM, Shopify.OptionSelectors),
Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function(t, e, o, i) {
    if (!Shopify.isDefined(o))
        var o = !0;
    if (!Shopify.isDefined(i))
        var i = "/";
    var r = document.getElementById(t)
      , n = r.childNodes
      , a = (r.parentNode,
    e.length)
      , s = [];
    Shopify.each(n, function(t, r) {
        if (1 == t.nodeType && "option" == t.tagName.toLowerCase()) {
            var n = t.innerHTML.split(new RegExp("\\s*\\" + i + "\\s*"));
            0 == e.length && (a = n.length - (o ? 1 : 0));
            var p = n.slice(0, a)
              , l = o ? n[a] : ""
              , c = (t.getAttribute("value"),
            {
                available: t.disabled ? !1 : !0,
                id: parseFloat(t.value),
                price: l,
                option1: p[0],
                option2: p[1],
                option3: p[2]
            });
            s.push(c)
        }
    });
    var p = {
        variants: s
    };
    if (0 == e.length) {
        p.options = [];
        for (var l = 0; a > l; l++)
            p.options[l] = "option " + (l + 1)
    } else
        p.options = e;
    return p
}
,
Shopify.SingleOptionSelector = function(t, e, o, i) {
    this.multiSelector = t,
    this.values = i,
    this.index = e,
    this.name = o,
    this.element = document.createElement("select");
    for (var r = 0; r < i.length; r++) {
        var n = document.createElement("option");
        n.value = i[r],
        n.innerHTML = i[r],
        this.element.appendChild(n)
    }
    return this.element.setAttribute("class", this.multiSelector.selectorClass),
    this.element.setAttribute("data-option", "option" + (e + 1)),
    this.element.id = t.domIdPrefix + "-option-" + e,
    this.element.onchange = function(o, i) {
        i = i || {},
        t.updateSelectors(e, i)
    }
    ,
    !0
}
,
Shopify.Image = {
    preload: function(t, e) {
        for (var o = 0; o < t.length; o++) {
            var i = t[o];
            this.loadImage(this.getSizedImageUrl(i, e))
        }
    },
    loadImage: function(t) {
        (new Image).src = t
    },
    switchImage: function(t, e, o) {
        if (t && e) {
            var i = this.imageSize(e.src)
              , r = this.getSizedImageUrl(t.src, i);
            o ? o(r, t, e) : e.src = r
        }
    },
    imageSize: function(t) {
        var e = t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);
        return null != e ? e[1] : null
    },
    getSizedImageUrl: function(t, e) {
        if (null == e)
            return t;
        if ("master" == e)
            return this.removeProtocol(t);
        var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (null != o) {
            var i = t.split(o[0])
              , r = o[0];
            return this.removeProtocol(i[0] + "_" + e + r)
        }
        return null
    },
    removeProtocol: function(t) {
        return t.replace(/http(s)?:/, "")
    }
},
Shopify.OptionSelectors.HistoryState = function(t) {
    this.browserSupports() && this.register(t)
}
,
Shopify.OptionSelectors.HistoryState.prototype.register = function(t) {
    window.addEventListener("popstate", function(e) {
        t.selectVariantFromParamsOrDropdown({
            popStateCall: !0
        })
    })
}
,
Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function(t, e, o) {
    this.browserSupports() && (!t || o.initialLoad || o.popStateCall || Shopify.setParam("variant", t.id))
}
,
Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function() {
    return window.history && window.history.replaceState
}
;

$(document).on('shopify:block:select', function(e) {

    var blockId = e.detail.blockId;
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')) {
        sliderBlock.select(blockId, $parentSection);
    }

    if ($parentSection.hasClass('page-details-section')) {
        if ($('.map-section').length) {
            mapFunction.init();
        }
    }

    if ($parentSection.hasClass('cart-section')) {
        if ($('.block__featured_collection').length) {
            featuredCollectionSection.init();
        }
    }

    if ($parentSection.hasClass('product-template')) {
    }

    utils.resizeActionButtons();

});

$(document).on('shopify:block:deselect', function(e) {

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')) {
        sliderBlock.deselect($parentSection)
    }

});

$(document).on('shopify:section:reorder', function(e) {

    utils.pageBannerCheck();

});

$(document).on('shopify:section:load', function(e) {

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    utils.pageBannerCheck();

    if ($parentSection.hasClass('image-gallery-section')) {
        gallery.init($parentSection);
    }

    if ($parentSection.hasClass('social-feeds-section')) {
        $('.social-feeds-wrap').each(function(index, value) {

            social.twitter();

            var $target = $(this).find(".js-instafeed");
            instagram.loadContent({
                el: $target,
                clientID: $target.data('client-id'),
                limit: $target.data('count'),
                column: $target.data('column')
            });
        });
    }

    if ($parentSection.hasClass('faq-section')) {
        faqAccordion.init();
    }

    if ($parentSection.hasClass('cart-section')) {
        cart.init();
        if ($('.block__featured_collection').length) {
            featuredCollectionSection.init();
        }
    }

    if ($parentSection.hasClass('featured-promotions-section')) {
        featuredPromotions.init();
    }

    if ($parentSection.hasClass('slideshow-section')) {
        slideshow.init();
    }

    if ($parentSection.hasClass('search-section')) {
        searchAutocomplete.init();
    }

    if ($parentSection.hasClass('testimonial-section')) {
        testimonial.init();
    }

    if ($parentSection.hasClass('featured-products-section')) {
        productPage.initializeQuantityBox();
        productPage.productSwatches();
        productPage.init();

    }

    if ($parentSection.hasClass('map-section')) {
        mapFunction.init();
    }

    if ($parentSection.hasClass('featured-collection-section')) {
        featuredCollectionSection.init();
    }

    if ($parentSection.hasClass('video-section')) {
        videoSection.init();
    }

    if ($parentSection.hasClass('recently-viewed__section')) {
        recentlyViewed.init();
    }

    if ($parentSection.hasClass('product-template')) {
        productPage.init();
        productPage.productSwatches();
        productPage.relatedProducts();
        recentlyViewed.init();

    }

    if ($parentSection.hasClass('article-template-section')) {
        if (window.location.pathname.indexOf('/comments') != -1) {
            $('html,body').animate({
                scrollTop: $("#new-comment").offset().top - 140
            }, 'slow');
        }
    }

    if ($parentSection.hasClass('collection-template-section')) {
        collectionSidebarFilter.init();
    }

    if ($parentSection.hasClass('contact-section')) {
        mapFunction.init();
    }

    if ($parentSection.hasClass('search-template-section')) {

        searchAutocomplete.init();

        collectionSidebarFilter.init();
    }

    if ($parentSection.hasClass('header-section')) {
        header.init();
        header.loadMegaMenu();
    }

    if ($parentSection.hasClass('mega-menu-section')) {
        header.loadMegaMenu();
    }

    if ($parentSection.hasClass('page-details-section')) {
        featuredCollectionSection.init();
        videoSection.init();
        if ($('.block__image_gallery').length) {
            gallery.init();
        }
        ;recentlyViewed.init();
    }

    if ($parentSection.hasClass('product-details-section')) {
        featuredCollectionSection.init();
        videoSection.init();
        mapFunction.init();
        if ($('.block__image_gallery').length) {
            gallery.init();
        }
        ;recentlyViewed.init();
    }
});

$(document).on('shopify:section:unload', function(e) {

    var $target = $(e.target);
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('header-section')) {
        header.unload($target);
        header.unloadMegaMenu();
    }

    if ($parentSection.hasClass('slideshow-section')) {
        slideshow.unload($target);
    }

    if ($parentSection.hasClass('testimonial-section')) {
        testimonial.unload($target);
    }

    if ($parentSection.hasClass('video-section')) {
        videoSection.unload($target);
    }

    if ($parentSection.hasClass('search-section')) {
        searchAutocomplete.unload($target);
    }

    if ($parentSection.hasClass('product-template')) {
        productPage.unload($target);
    }

    if ($parentSection.hasClass('mega-menu-section')) {
        header.unloadMegaMenu();
    }

    if ($parentSection.hasClass('page-details-section')) {
        videoSection.unload($target);
    }

    if ($parentSection.hasClass('product-details-section')) {
        videoSection.unload($target);
    }

});

$(document).on('shopify:section:select', function(e) {

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('social-feeds-section')) {
        $('.social-feeds-wrap').each(function(index, value) {
            social.twitter();
        });
    }

    if ($parentSection.hasClass('mega-menu-section')) {
        var megaMenuParent = $('.header .' + e.detail.sectionId).data('dropdown');
        setTimeout(function() {
            $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger('mouseenter');
            $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').parents('header').addClass('editor-hover--true');
            header.removeDataAttributes('.header .mega-menu.dropdown_container .dropdown_column');
        }, 10);
    }

    if ($parentSection.hasClass('featured-collection-section')) {
        featuredCollectionSection.unload($parentSection);
        featuredCollectionSection.init();
    }

    utils.pageBannerCheck();
    var evt = document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
});

$(document).on('shopify:section:deselect', function(e) {

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('mega-menu-section')) {
        var megaMenuParent = $('.header .' + e.detail.sectionId).data('dropdown');
        $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger('mouseout');
        $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').parents('header').removeClass('editor-hover--true');
    }
});

/* HOTSPOT JS */
/**
 * jQuery plugin for Responsive Hotspot
 *
 * Author: SK Lam
 */
(function() {
    'use strict';

    /*
		Reposition the HotSpots during init and resize windows
	*/
    function _positionHotspots(options) {
        var imageWidth = $(options.mainselector + ' ' + options.imageselector).prop('naturalWidth');
        var imageHeight = $(options.mainselector + ' ' + options.imageselector).prop('naturalHeight');

        var bannerWidth = $(options.mainselector).width();
        var bannerHeight = $(options.mainselector).height();
        $(options.selector).each(function() {
            var xPos = $(this).attr('x');
            var yPos = $(this).attr('y');
            xPos = xPos / imageWidth * bannerWidth;
            yPos = yPos / imageHeight * bannerHeight;

            $(this).css({
                'top': yPos,
                'left': xPos,
                'display': 'block',
            });
            $(this).children(options.tooltipselector).css({
                'margin-left': -($(this).children(options.tooltipselector).width() / 2)
            });
        });
    }

    // Bind the events (hover or click) for the tooltip
    function _bindHotspots(e, options) {
        if ($(e).children(options.tooltipselector).is(':visible')) {
            $(e).children(options.tooltipselector).css('display', 'none');
        } else {
            $(options.selector + ' ' + options.tooltipselector).css('display', 'none');
            $(e).children(options.tooltipselector).css('display', 'block');
            if ($(window).width() - ($(e).children(options.tooltipselector).offset().left + $(e).children(options.tooltipselector).outerWidth()) < 0) {
                $(e).children(options.tooltipselector).css({
                    'right': '0',
                    'left': 'auto',
                });
            }
        }
    }

    $.fn.hotSpot = function(options) {

        // Extend our default options with those provided.
        // Note that the first argument to extend is an empty
        // object – this is to keep from overriding our "defaults" object.
        var _options = $.extend({}, $.fn.hotSpot.defaults, options);

        // Position each hotspot
        this.each(function() {
            _positionHotspots.call($(this), _options);
        });

        // Bind the windows resize event to recalculate the hotspot position
        $(window).resize(function() {
            this.each(function() {
                _positionHotspots.call($(this), _options);
            });
        }
        .bind(this));

        // Bind the hover/click for selector to show the tooltip
        switch (_options.bindselector) {
        case 'click':
            $(_options.selector).bind('click', function(e) {
                _bindHotspots(e.currentTarget, _options)
            });
            break;
        case 'hover':
            $(_options.selector).hover(function(e) {
                _bindHotspots(e.currentTarget, _options)
            });
            break;
        default:
            break;
        }

        return this;
    }
    ;

    // Plugin defaults
    $.fn.hotSpot.defaults = {
        mainselector: '#hotspotImg',
        selector: '.hot-spot',
        imageselector: '.img-responsive',
        tooltipselector: '.tooltip',
        bindselector: 'hover'
    };
}(jQuery));

$(document).ready(function() {

    if ($('#hotspotImg').length > 0) {
        $('#hotspotImg').hotSpot({
            bindselector: 'hover'
        });
    }

    //   training course switch
    $('.quality-course .scan-service-cell').click(function() {
        var triger = $(this).data('triger');
        console.log(triger);
        $('.training-course').hide();
        $('.' + triger).show();
    });
});

// SVG creating
$(function() {
    jQuery('img.svg').each(function() {
        var $img = jQuery(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        jQuery.get(imgURL, function(data) {
            // Get the SVG tag, ignore the rest
            var $svg = jQuery(data).find('svg');

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }
            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Check if the viewport is set, else we gonna set it if we can.
            if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
            }

            // Replace image with new SVG
            $img.replaceWith($svg);

        }, 'xml');

    });
});

//smooth scroll JS
/* == Page scroll to id == Version: 1.6.2, License: MIT License (MIT) */
!function($, window, document, undefined) {
    var selector, opt, _init, _trigger, _clicked, _target, _to, _axis, _offset, _dataOffset, _liveTimer, _speed, defaults = {
        scrollSpeed: 1e3,
        autoScrollSpeed: !0,
        scrollEasing: "easeInOutQuint",
        scrollingEasing: "easeOutQuint",
        pageEndSmoothScroll: !0,
        layout: "vertical",
        offset: 0,
        highlightSelector: !1,
        clickedClass: "mPS2id-clicked",
        targetClass: "mPS2id-target",
        highlightClass: "mPS2id-highlight",
        forceSingleHighlight: !1,
        keepHighlightUntilNext: !1,
        highlightByNextTarget: !1,
        disablePluginBelow: !1,
        clickEvents: !0,
        appendHash: !1,
        onStart: function() {},
        onComplete: function() {},
        defaultSelector: !1,
        live: !0,
        liveSelector: !1,
        excludeSelectors: !1
    }, _totalInstances = 0, methods = {
        init: function(options) {
            options = $.extend(!0, {}, defaults, options);
            if ($(document).data("mPS2id", options),
            opt = $(document).data("mPS2id"),
            !this.selector) {
                this.each(function() {
                    var el = $(this);
                    el.hasClass("__mPS2id") || el.addClass("__mPS2id")
                }),
                this.selector = ".__mPS2id"
            }
            opt.liveSelector && (this.selector += "," + opt.liveSelector),
            selector = selector ? selector + "," + this.selector : this.selector,
            opt.defaultSelector && ("object" == typeof $(selector) && 0 !== $(selector).length || (selector = ".m_PageScroll2id,a[rel~='m_PageScroll2id'],.page-scroll-to-id,a[rel~='page-scroll-to-id'],._ps2id")),
            opt.clickEvents && $(document).undelegate(".mPS2id").delegate(selector, "click.mPS2id", function(e) {
                if (functions._isDisabled.call(null))
                    functions._removeClasses.call(null);
                else {
                    var $this = $(this)
                      , href = $this.attr("href")
                      , hrefProp = $this.prop("href").baseVal || $this.prop("href");
                    opt.excludeSelectors && $this.is(opt.excludeSelectors) || href && -1 !== href.indexOf("#/") || (functions._reset.call(null),
                    _dataOffset = $this.data("ps2id-offset") || 0,
                    functions._isValid.call(null, href, hrefProp) && functions._findTarget.call(null, href) && (e.preventDefault(),
                    _trigger = "selector",
                    _clicked = $this,
                    functions._setClasses.call(null, !0),
                    functions._scrollTo.call(null)))
                }
            }),
            $(window).unbind(".mPS2id").bind("scroll.mPS2id resize.mPS2id", function() {
                if (functions._isDisabled.call(null))
                    functions._removeClasses.call(null);
                else {
                    var targets = $("._mPS2id-t");
                    targets.each(function(i) {
                        var t = $(this)
                          , id = t.attr("id")
                          , h = functions._findHighlight.call(null, id);
                        functions._setClasses.call(null, !1, t, h),
                        i == targets.length - 1 && functions._extendClasses.call(null)
                    })
                }
            }),
            _init = !0,
            functions._setup.call(null),
            functions._live.call(null)
        },
        scrollTo: function(id, options) {
            if (functions._isDisabled.call(null))
                functions._removeClasses.call(null);
            else if (id && void 0 !== id) {
                functions._isInit.call(null);
                var defaults = {
                    layout: opt.layout,
                    offset: opt.offset,
                    clicked: !1
                };
                options = $.extend(!0, {}, defaults, options);
                functions._reset.call(null),
                _axis = options.layout,
                _offset = options.offset,
                id = -1 !== id.indexOf("#") ? id : "#" + id,
                functions._isValid.call(null, id) && functions._findTarget.call(null, id) && (_trigger = "scrollTo",
                (_clicked = options.clicked) && functions._setClasses.call(null, !0),
                functions._scrollTo.call(null))
            }
        },
        destroy: function() {
            $(window).unbind(".mPS2id"),
            $(document).undelegate(".mPS2id").removeData("mPS2id"),
            $("._mPS2id-t").removeData("mPS2id"),
            functions._removeClasses.call(null, !0)
        }
    }, functions = {
        _isDisabled: function() {
            var e = window
              , a = "inner"
              , val = opt.disablePluginBelow instanceof Array ? [opt.disablePluginBelow[0] || 0, opt.disablePluginBelow[1] || 0] : [opt.disablePluginBelow || 0, 0];
            return "innerWidth"in window || (a = "client",
            e = document.documentElement || document.body),
            e[a + "Width"] <= val[0] || e[a + "Height"] <= val[1]
        },
        _isValid: function(href, hrefProp) {
            if (href) {
                var str = -1 !== (hrefProp = hrefProp || href).indexOf("#/") ? hrefProp.split("#/")[0] : hrefProp.split("#")[0]
                  , loc = window.location.toString().split("#")[0];
                return "#" !== href && -1 !== href.indexOf("#") && ("" === str || decodeURIComponent(str) === decodeURIComponent(loc))
            }
        },
        _setup: function() {
            var el = functions._highlightSelector()
              , i = 1
              , tp = 0;
            return $(el).each(function() {
                var $this = $(this)
                  , href = $this.attr("href")
                  , hrefProp = $this.prop("href").baseVal || $this.prop("href");
                if (functions._isValid.call(null, href, hrefProp)) {
                    if (opt.excludeSelectors && $this.is(opt.excludeSelectors))
                        return;
                    var id = -1 !== href.indexOf("#/") ? href.split("#/")[1] : href.split("#")[1]
                      , t = $("#" + id);
                    if (0 < t.length) {
                        opt.highlightByNextTarget && t !== tp && (tp ? tp.data("mPS2id", {
                            tn: t
                        }) : t.data("mPS2id", {
                            tn: "0"
                        }),
                        tp = t),
                        t.hasClass("_mPS2id-t") || t.addClass("_mPS2id-t"),
                        t.data("mPS2id", {
                            i: i
                        }),
                        $this.hasClass("_mPS2id-h") || $this.addClass("_mPS2id-h");
                        var h = functions._findHighlight.call(null, id);
                        functions._setClasses.call(null, !1, t, h),
                        _totalInstances = i,
                        ++i == $(el).length && functions._extendClasses.call(null)
                    }
                }
            })
        },
        _highlightSelector: function() {
            return opt.highlightSelector && "" !== opt.highlightSelector ? opt.highlightSelector : selector
        },
        _findTarget: function(str) {
            var val = -1 !== str.indexOf("#/") ? str.split("#/")[1] : str.split("#")[1]
              , el = $("#" + val);
            if (el.length < 1 || "fixed" === el.css("position")) {
                if ("top" !== val)
                    return;
                el = $("body")
            }
            return _target = el,
            _axis || (_axis = opt.layout),
            _offset = functions._setOffset.call(null),
            (_to = [(el.offset().top - _offset[0]).toString(), (el.offset().left - _offset[1]).toString()])[0] = _to[0] < 0 ? 0 : _to[0],
            _to[1] = _to[1] < 0 ? 0 : _to[1],
            _to
        },
        _setOffset: function() {
            var val, obj, y, x;
            switch (_offset || (_offset = opt.offset ? opt.offset : 0),
            _dataOffset && (_offset = _dataOffset),
            typeof _offset) {
            case "object":
            case "string":
                0 < (obj = [(val = [_offset.y ? _offset.y : _offset, _offset.x ? _offset.x : _offset])[0]instanceof jQuery ? val[0] : $(val[0]), val[1]instanceof jQuery ? val[1] : $(val[1])])[0].length ? (y = obj[0].height(),
                "fixed" === obj[0].css("position") && (y += obj[0][0].offsetTop)) : y = !isNaN(parseFloat(val[0])) && isFinite(val[0]) ? parseInt(val[0]) : 0,
                0 < obj[1].length ? (x = obj[1].width(),
                "fixed" === obj[1].css("position") && (x += obj[1][0].offsetLeft)) : x = !isNaN(parseFloat(val[1])) && isFinite(val[1]) ? parseInt(val[1]) : 0;
                break;
            case "function":
                (val = _offset.call(null))instanceof Array ? (y = val[0],
                x = val[1]) : y = x = val;
                break;
            default:
                y = x = parseInt(_offset)
            }
            return [y, x]
        },
        _findHighlight: function(id) {
            var wLoc = window.location
              , loc = wLoc.toString().split("#")[0]
              , locPath = wLoc.pathname;
            return -1 !== loc.indexOf("'") && (loc = loc.replace("'", "\\'")),
            -1 !== locPath.indexOf("'") && (locPath = locPath.replace("'", "\\'")),
            loc = decodeURIComponent(loc),
            locPath = decodeURIComponent(locPath),
            $("._mPS2id-h[href='#" + id + "'],._mPS2id-h[href='" + loc + "#" + id + "'],._mPS2id-h[href='" + locPath + "#" + id + "'],._mPS2id-h[href='#/" + id + "'],._mPS2id-h[href='" + loc + "#/" + id + "'],._mPS2id-h[href='" + locPath + "#/" + id + "']")
        },
        _setClasses: function(c, t, h) {
            var cc = opt.clickedClass
              , tc = opt.targetClass
              , hc = opt.highlightClass;
            c && cc && "" !== cc ? ($("." + cc).removeClass(cc),
            _clicked.addClass(cc)) : t && tc && "" !== tc && h && hc && "" !== hc && (functions._currentTarget.call(null, t) ? (t.addClass(tc),
            h.addClass(hc)) : (!opt.keepHighlightUntilNext || 1 < $("." + hc).length) && (t.removeClass(tc),
            h.removeClass(hc)))
        },
        _extendClasses: function() {
            var tc = opt.targetClass
              , hc = opt.highlightClass
              , $tc = $("." + tc)
              , $hc = $("." + hc)
              , ftc = tc + "-first"
              , ltc = tc + "-last"
              , fhc = hc + "-first"
              , lhc = hc + "-last";
            $("._mPS2id-t").removeClass(ftc + " " + ltc),
            $("._mPS2id-h").removeClass(fhc + " " + lhc),
            opt.forceSingleHighlight ? opt.keepHighlightUntilNext && 1 < $tc.length ? ($tc.slice(0, 1).removeClass(tc),
            $hc.slice(0, 1).removeClass(hc)) : ($tc.slice(1).removeClass(tc),
            $hc.slice(1).removeClass(hc)) : ($tc.slice(0, 1).addClass(ftc).end().slice(-1).addClass(ltc),
            $hc.slice(0, 1).addClass(fhc).end().slice(-1).addClass(lhc))
        },
        _removeClasses: function(destroy) {
            $("." + opt.clickedClass).removeClass(opt.clickedClass),
            $("." + opt.targetClass).removeClass(opt.targetClass + " " + opt.targetClass + "-first " + opt.targetClass + "-last"),
            $("." + opt.highlightClass).removeClass(opt.highlightClass + " " + opt.highlightClass + "-first " + opt.highlightClass + "-last"),
            destroy && ($("._mPS2id-t").removeClass("_mPS2id-t"),
            $("._mPS2id-h").removeClass("_mPS2id-h"))
        },
        _currentTarget: function(t) {
            var o = opt["target_" + t.data("mPS2id").i]
              , dataTarget = t.data("ps2id-target")
              , rect = dataTarget && $(dataTarget)[0] ? $(dataTarget)[0].getBoundingClientRect() : t[0].getBoundingClientRect();
            if (void 0 !== o) {
                var y = t.offset().top
                  , x = t.offset().left
                  , from = o.from ? o.from + y : y
                  , to = o.to ? o.to + y : y
                  , fromX = o.fromX ? o.fromX + x : x
                  , toX = o.toX ? o.toX + x : x;
                return rect.top >= to && rect.top <= from && rect.left >= toX && rect.left <= fromX
            }
            var wh = $(window).height()
              , ww = $(window).width()
              , th = dataTarget ? $(dataTarget).height() : t.height()
              , tw = dataTarget ? $(dataTarget).width() : t.width()
              , base = 1 + th / wh
              , top = base
              , bottom = th < wh ? base * (wh / th) : base
              , baseX = 1 + tw / ww
              , left = baseX
              , right = tw < ww ? baseX * (ww / tw) : baseX
              , val = [rect.top <= wh / top, rect.bottom >= wh / bottom, rect.left <= ww / left, rect.right >= ww / right];
            if (opt.highlightByNextTarget) {
                var tn = t.data("mPS2id").tn;
                if (tn) {
                    var rectn = tn[0].getBoundingClientRect();
                    "vertical" === opt.layout ? val = [rect.top <= wh / 2, rectn.top > wh / 2, 1, 1] : "horizontal" === opt.layout && (val = [1, 1, rect.left <= ww / 2, rectn.left > ww / 2])
                }
            }
            return val[0] && val[1] && val[2] && val[3]
        },
        _scrollTo: function() {
            _speed = functions._scrollSpeed.call(null),
            _to = opt.pageEndSmoothScroll ? functions._pageEndSmoothScroll.call(null) : _to;
            var _scrollable = $("html,body")
              , speed = opt.autoScrollSpeed ? functions._autoScrollSpeed.call(null) : _speed
              , easing = _scrollable.is(":animated") ? opt.scrollingEasing : opt.scrollEasing
              , _t = $(window).scrollTop()
              , _l = $(window).scrollLeft();
            switch (_axis) {
            case "horizontal":
                _l != _to[1] && (functions._callbacks.call(null, "onStart"),
                _scrollable.stop().animate({
                    scrollLeft: _to[1]
                }, speed, easing).promise().then(function() {
                    functions._callbacks.call(null, "onComplete")
                }));
                break;
            case "auto":
                var left;
                if (_t != _to[0] || _l != _to[1])
                    if (functions._callbacks.call(null, "onStart"),
                    navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/))
                        _scrollable.stop().animate({
                            pageYOffset: _to[0],
                            pageXOffset: _to[1]
                        }, {
                            duration: speed,
                            easing: easing,
                            step: function(now, fx) {
                                "pageXOffset" == fx.prop ? left = now : "pageYOffset" == fx.prop && window.scrollTo(left, now)
                            }
                        }).promise().then(function() {
                            functions._callbacks.call(null, "onComplete")
                        });
                    else
                        _scrollable.stop().animate({
                            scrollTop: _to[0],
                            scrollLeft: _to[1]
                        }, speed, easing).promise().then(function() {
                            functions._callbacks.call(null, "onComplete")
                        });
                break;
            default:
                _t != _to[0] && (functions._callbacks.call(null, "onStart"),
                _scrollable.stop().animate({
                    scrollTop: _to[0]
                }, speed, easing).promise().then(function() {
                    functions._callbacks.call(null, "onComplete")
                }))
            }
        },
        _pageEndSmoothScroll: function() {
            var _dh = $(document).height()
              , _dw = $(document).width()
              , _wh = $(window).height()
              , _ww = $(window).width();
            return [_dh - _to[0] < _wh ? _dh - _wh : _to[0], _dw - _to[1] < _ww ? _dw - _ww : _to[1]]
        },
        _scrollSpeed: function() {
            var speed = opt.scrollSpeed;
            return _clicked && _clicked.length && _clicked.add(_clicked.parent()).each(function() {
                var $this = $(this);
                if ($this.attr("class")) {
                    var clickedClasses = $this.attr("class").split(" ");
                    for (var index in clickedClasses)
                        if (String(clickedClasses[index]).match(/^ps2id-speed-\d+$/)) {
                            speed = clickedClasses[index].split("ps2id-speed-")[1];
                            break
                        }
                }
            }),
            parseInt(speed)
        },
        _autoScrollSpeed: function() {
            var _t = $(window).scrollTop()
              , _l = $(window).scrollLeft()
              , _h = $(document).height()
              , _w = $(document).width()
              , val = [_speed + _speed * Math.floor(Math.abs(_to[0] - _t) / _h * 100) / 100, _speed + _speed * Math.floor(Math.abs(_to[1] - _l) / _w * 100) / 100];
            return Math.max.apply(Math, val)
        },
        _callbacks: function(c) {
            if (opt)
                switch (this.mPS2id = {
                    trigger: _trigger,
                    clicked: _clicked,
                    target: _target,
                    scrollTo: {
                        y: _to[0],
                        x: _to[1]
                    }
                },
                c) {
                case "onStart":
                    if (opt.appendHash && window.history && window.history.pushState && _clicked && _clicked.length) {
                        var h = "#" + _clicked.attr("href").split("#")[1];
                        h !== window.location.hash && history.pushState("", "", h)
                    }
                    opt.onStart.call(null, this.mPS2id);
                    break;
                case "onComplete":
                    opt.onComplete.call(null, this.mPS2id)
                }
        },
        _reset: function() {
            _axis = _offset = _dataOffset = !1
        },
        _isInit: function() {
            _init || methods.init.apply(this)
        },
        _live: function() {
            _liveTimer = setTimeout(function() {
                opt.live ? $(functions._highlightSelector()).length !== _totalInstances && functions._setup.call(null) : _liveTimer && clearTimeout(_liveTimer),
                functions._live.call(null)
            }, 1e3)
        },
        _easing: function() {
            function __bounceOut(x) {
                var n1 = 7.5625
                  , d1 = 2.75;
                return x < 1 / d1 ? n1 * x * x : x < 2 / d1 ? n1 * (x -= 1.5 / d1) * x + .75 : x < 2.5 / d1 ? n1 * (x -= 2.25 / d1) * x + .9375 : n1 * (x -= 2.625 / d1) * x + .984375
            }
            $.easing.easeInQuad = $.easing.easeInQuad || function(x) {
                return x * x
            }
            ,
            $.easing.easeOutQuad = $.easing.easeOutQuad || function(x) {
                return 1 - (1 - x) * (1 - x)
            }
            ,
            $.easing.easeInOutQuad = $.easing.easeInOutQuad || function(x) {
                return x < .5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2
            }
            ,
            $.easing.easeInCubic = $.easing.easeInCubic || function(x) {
                return x * x * x
            }
            ,
            $.easing.easeOutCubic = $.easing.easeOutCubic || function(x) {
                return 1 - Math.pow(1 - x, 3)
            }
            ,
            $.easing.easeInOutCubic = $.easing.easeInOutCubic || function(x) {
                return x < .5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2
            }
            ,
            $.easing.easeInQuart = $.easing.easeInQuart || function(x) {
                return x * x * x * x
            }
            ,
            $.easing.easeOutQuart = $.easing.easeOutQuart || function(x) {
                return 1 - Math.pow(1 - x, 4)
            }
            ,
            $.easing.easeInOutQuart = $.easing.easeInOutQuart || function(x) {
                return x < .5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2
            }
            ,
            $.easing.easeInQuint = $.easing.easeInQuint || function(x) {
                return x * x * x * x * x
            }
            ,
            $.easing.easeOutQuint = $.easing.easeOutQuint || function(x) {
                return 1 - Math.pow(1 - x, 5)
            }
            ,
            $.easing.easeInOutQuint = $.easing.easeInOutQuint || function(x) {
                return x < .5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2
            }
            ,
            $.easing.easeInExpo = $.easing.easeInExpo || function(x) {
                return 0 === x ? 0 : Math.pow(2, 10 * x - 10)
            }
            ,
            $.easing.easeOutExpo = $.easing.easeOutExpo || function(x) {
                return 1 === x ? 1 : 1 - Math.pow(2, -10 * x)
            }
            ,
            $.easing.easeInOutExpo = $.easing.easeInOutExpo || function(x) {
                return 0 === x ? 0 : 1 === x ? 1 : x < .5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2
            }
            ,
            $.easing.easeInSine = $.easing.easeInSine || function(x) {
                return 1 - Math.cos(x * Math.PI / 2)
            }
            ,
            $.easing.easeOutSine = $.easing.easeOutSine || function(x) {
                return Math.sin(x * Math.PI / 2)
            }
            ,
            $.easing.easeInOutSine = $.easing.easeInOutSine || function(x) {
                return -(Math.cos(Math.PI * x) - 1) / 2
            }
            ,
            $.easing.easeInCirc = $.easing.easeInCirc || function(x) {
                return 1 - Math.sqrt(1 - Math.pow(x, 2))
            }
            ,
            $.easing.easeOutCirc = $.easing.easeOutCirc || function(x) {
                return Math.sqrt(1 - Math.pow(x - 1, 2))
            }
            ,
            $.easing.easeInOutCirc = $.easing.easeInOutCirc || function(x) {
                return x < .5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2
            }
            ,
            $.easing.easeInElastic = $.easing.easeInElastic || function(x) {
                return 0 === x ? 0 : 1 === x ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((10 * x - 10.75) * (2 * Math.PI / 3))
            }
            ,
            $.easing.easeOutElastic = $.easing.easeOutElastic || function(x) {
                return 0 === x ? 0 : 1 === x ? 1 : Math.pow(2, -10 * x) * Math.sin((10 * x - .75) * (2 * Math.PI / 3)) + 1
            }
            ,
            $.easing.easeInOutElastic = $.easing.easeInOutElastic || function(x) {
                return 0 === x ? 0 : 1 === x ? 1 : x < .5 ? -Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * (2 * Math.PI / 4.5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * (2 * Math.PI / 4.5)) / 2 + 1
            }
            ,
            $.easing.easeInBack = $.easing.easeInBack || function(x) {
                return 2.70158 * x * x * x - 1.70158 * x * x
            }
            ,
            $.easing.easeOutBack = $.easing.easeOutBack || function(x) {
                return 1 + 2.70158 * Math.pow(x - 1, 3) + 1.70158 * Math.pow(x - 1, 2)
            }
            ,
            $.easing.easeInOutBack = $.easing.easeInOutBack || function(x) {
                return x < .5 ? Math.pow(2 * x, 2) * (7.189819 * x - 2.5949095) / 2 : (Math.pow(2 * x - 2, 2) * (3.5949095 * (2 * x - 2) + 2.5949095) + 2) / 2
            }
            ,
            $.easing.easeInBounce = $.easing.easeInBounce || function(x) {
                return 1 - __bounceOut(1 - x)
            }
            ,
            $.easing.easeOutBounce = $.easing.easeOutBounce || __bounceOut,
            $.easing.easeInOutBounce = $.easing.easeInOutBounce || function(x) {
                return x < .5 ? (1 - __bounceOut(1 - 2 * x)) / 2 : (1 + __bounceOut(2 * x - 1)) / 2
            }
        }
    };
    functions._easing.call(),
    $.fn.mPageScroll2id = function(method) {
        return methods[method] ? methods[method].apply(this, Array.prototype.slice.call(arguments, 1)) : "object" != typeof method && method ? void $.error("Method " + method + " does not exist") : methods.init.apply(this, arguments)
    }
    ,
    $.mPageScroll2id = function(method) {
        return methods[method] ? methods[method].apply(this, Array.prototype.slice.call(arguments, 1)) : "object" != typeof method && method ? void $.error("Method " + method + " does not exist") : methods.init.apply(this, arguments)
    }
    ,
    $.mPageScroll2id.defaults = defaults
}(jQuery, window, document);
(function($) {
    $(window).on("load", function() {

        /* Page Scroll to id fn call */
        $(".scan-hero-button-group a").mPageScroll2id({
            highlightSelector: ".scan-hero-button-group a"
        });

    });
}
)(jQuery);
